var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shared-node"
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-col": {
        span: 24
      },
      "wrapper-col": {
        span: 24
      },
      rules: _vm.rules
    }
  }, _vm._l(_vm.sharedNodeInfo, function (shareNode) {
    return _c("div", {
      key: `share+${shareNode.step}`
    }, [shareNode && shareNode.step === 1 && _vm.showPolicyInfo ? _c("top-title", [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t("保单信息")))])]) : _vm._e(), shareNode && shareNode.step === 1 && _vm.showPolicyInfo ? _c("div", {
      staticClass: "infoBox"
    }, [_c("div", [_vm._v(_vm._s(_vm.$t("保单号")) + " ：" + _vm._s(_vm.policyInfo.policyNo))]), _c("div", [_vm._v(_vm._s(_vm.$t("产品名称")) + "：" + _vm._s(_vm.policyInfo.insuranceName))]), _c("div", [_vm._v(_vm._s(_vm.$t("生效日期")) + "：" + _vm._s(_vm.policyInfo.startAt))]), _c("div", [_vm._v(_vm._s(_vm.$t("终止日期")) + "：" + _vm._s(_vm.policyInfo.endAt))]), _c("div", [_vm._v(_vm._s(_vm.$t("保单状态")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.policyStatus)))]), _c("div", [_vm._v(_vm._s(_vm.$t("承保单位")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.unitName)))]), _c("div", [_vm._v(_vm._s(_vm.$t("机构全称")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.agencyName)))]), _c("div", [_vm._v(_vm._s(_vm.$t("保单归属")) + "：" + _vm._s(_vm.$t(_vm.policyInfo.customerName)))])]) : _vm._e(), shareNode.method === "COUNTERSIGN" ? _c("div", [_vm._l(shareNode.editableArea, function (item3) {
      return [_vm._l(item3.editableArea, function (formItem, index) {
        return [formItem.formName && formItem.source !== "personnelReplace" ? _c("top-title", {
          key: index
        }, [_c("span", {
          attrs: {
            slot: "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(formItem.formName)))])]) : _vm._e(), formItem.source !== "personnelReplace" ? _vm._l(formItem.form, function (item2, controlIndex) {
          return _c("div", {
            key: controlIndex
          }, [item2.controlType === "control" && _vm.showControl[item2.control.mark] ? _c("div", [_c("formControlItem", {
            ref: `control${item2.control.mark}`,
            refInFor: true,
            attrs: {
              formData: _vm.formData,
              controlItem: item2.control,
              echoNodeIsEdit: _vm.echoNodeIsEdit && shareNode.isEdit,
              associationInfo: _vm.associationInfo
            },
            on: {
              valueChange: _vm.valueChangeValidate,
              changeControlShow: _vm.changeControlShow
            }
          })], 1) : item2.controlType === "controlGroup" && _vm.showControl[item2.mark] ? _c("div", [_c("h4", [_vm._v(_vm._s(item2.controlName))]), _vm._l(item2.control, function (subControl, subControlIndex) {
            return _c("div", {
              key: subControlIndex
            }, [_c("formControlItem", {
              ref: `control${subControl.mark}`,
              refInFor: true,
              attrs: {
                formData: _vm.formData,
                controlItem: subControl,
                echoNodeIsEdit: _vm.echoNodeIsEdit && shareNode.isEdit,
                associationInfo: _vm.associationInfo
              },
              on: {
                valueChange: _vm.valueChangeValidate,
                changeControlShow: _vm.changeControlShow
              }
            })], 1);
          })], 2) : _vm._e()]);
        }) : _vm._e()];
      })];
    })], 2) : shareNode.source !== "personnelReplace" ? _vm._l(shareNode.editableArea, function (formItem, index) {
      return [formItem.formName && formItem.source !== "personnelReplace" ? _c("top-title", {
        key: index
      }, [_c("span", {
        attrs: {
          slot: "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(_vm.$t(formItem.formName)))])]) : _vm._e(), formItem.source !== "personnelReplace" ? _vm._l(formItem.form, function (item2, controlIndex) {
        return _c("div", {
          key: controlIndex
        }, [item2.controlType === "control" && _vm.showControl[item2.control.mark] ? _c("div", [_c("formControlItem", {
          ref: `control${item2.control.mark}`,
          refInFor: true,
          attrs: {
            formData: _vm.formData,
            controlItem: item2.control,
            echoNodeIsEdit: _vm.echoNodeIsEdit && shareNode.isEdit,
            associationInfo: _vm.associationInfo
          },
          on: {
            valueChange: _vm.valueChangeValidate,
            changeControlShow: _vm.changeControlShow
          }
        })], 1) : item2.controlType === "controlGroup" && _vm.showControl[item2.mark] ? _c("div", [_c("h4", [_vm._v(_vm._s(item2.controlName))]), _vm._l(item2.control, function (subControl, subControlIndex) {
          return _c("div", {
            key: subControlIndex
          }, [_c("formControlItem", {
            ref: `control${subControl.mark}`,
            refInFor: true,
            attrs: {
              formData: _vm.formData,
              controlItem: subControl,
              echoNodeIsEdit: _vm.echoNodeIsEdit && shareNode.isEdit,
              associationInfo: _vm.associationInfo
            },
            on: {
              valueChange: _vm.valueChangeValidate,
              changeControlShow: _vm.changeControlShow
            }
          })], 1);
        })], 2) : _vm._e()]);
      }) : _vm._e()];
    }) : _vm._e()], 2);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };